import { render, staticRenderFns } from "./SelectRelatedHazards.vue?vue&type=template&id=5c7d42a8&"
import script from "./SelectRelatedHazards.vue?vue&type=script&lang=js&"
export * from "./SelectRelatedHazards.vue?vue&type=script&lang=js&"
import style0 from "./SelectRelatedHazards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports